import { FC, useEffect } from "react";
import { getActiveMenuAndExpandedSubMenus } from "@utils/app.util";
import { useLocation } from "react-router-dom";
import { useActiveMenu } from "@contexts/active-menu-state.context";
import { Menu } from "./menu";
import { AppMenuSchemaType } from "@dialogs/app-add-edit-dialog/app-add-edit-form.schema";

interface AppMenuContainerProps {
  menuData: AppMenuSchemaType[];
  appId?: string;
  className?: string;
  menuMap: {
    [x: string]: AppMenuSchemaType;
  };
  fontColor?: string;
  bgColor?: string;
  toggleLeftMenu?: (value?: boolean) => void;
}

export const AppMenuContainer: FC<AppMenuContainerProps> = ({
  menuData,
  appId,
  menuMap,
  fontColor,
  bgColor,
  toggleLeftMenu,
}) => {
  const { setActiveMenu, setExpandedSubMenus } = useActiveMenu();
  const location = useLocation();

  useEffect(() => {
    const result = getActiveMenuAndExpandedSubMenus(location.pathname, menuMap, appId as string);
    if (!result) {
      return;
    } else {
      // Set Active Menu and Expand sub-menus based on location
      setActiveMenu(result.activeMenu);
      setExpandedSubMenus((prevState) => ({
        ...prevState,
        ...result.expandedSubMenus,
      }));
    }
  }, [appId, location.pathname, menuMap, setActiveMenu, setExpandedSubMenus]);

  return (
    <Menu
      menuData={menuData}
      appId={appId}
      fontColor={fontColor}
      bgColor={bgColor}
      toggleLeftMenu={toggleLeftMenu}
    />
  );
};
